"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileStackRoot = void 0;

var _emotion = require("emotion");

var fileStackRoot =
/*#__PURE__*/
(0, _emotion.css)("cursor:pointer;:focus{outline:none;}");
exports.fileStackRoot = fileStackRoot;